module.exports = ".example-fill-remaining-space {\r\n    /* This fills the remaining space, by using flexbox. \r\n       Every toolbar row uses a flexbox row layout. */\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 auto;\r\n            flex: 1 1 auto;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/toolbar/toolbar.component.css
// module id = ./src/app/ui/toolbar/toolbar.component.css
// module chunks = main